module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-2-svgrepo-com.166ae25a.svg";